import React from 'react'
import { Box, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

import { DateRangeFilterButton, DateRangeFilterButtonProps } from '../../DatePicker'

const useStyles = makeStyles()(theme => ({
  dateRangeContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
}))

/**
 * Date range component for the filters
 * @param props - Props of the date range filter button component
 */
export const DateRangeWithLabel: React.FC<DateRangeFilterButtonProps> = props => {
  const { classes } = useStyles()

  return (
    <Box className={classes.dateRangeContainer}>
      <Typography variant="body2">{props.title}</Typography>
      <DateRangeFilterButton {...props} />
    </Box>
  )
}
